module.exports = __webpack_public_path__ + "static/img/img-16.4ea674c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-16.png
// module id = cSxG
// module chunks = 1